export const PRICE_SPIDER_ACCOUNT = process.env.NEXT_PUBLIC_PRICE_SPIDER_ACCOUNT;
export const PRICE_SPIDER_CONFIG_LOCAL = process.env.NEXT_PUBLIC_PRICE_SPIDER_CONFIG_LOCAL;
export const PRICE_SPIDER_CONFIG_ONLINE = process.env.NEXT_PUBLIC_PRICE_SPIDER_CONFIG_ONLINE;
export const PRICE_SPIDER_SCRIPT_URL = process.env.NEXT_PUBLIC_PRICE_SPIDER_SCRIPT_URL;
